const QUANT_PORTFOLIO_CLIENT_FILTERS = ["individual_client_id", "corporation_client_id"] as const;

type QuantPortfolioClientFilter = (typeof QUANT_PORTFOLIO_CLIENT_FILTERS)[number];

export interface QuantPortfolioOwner {
  filter: QuantPortfolioClientFilter;
  clientId: string;
}

export function quantPortfolioListQuery(owner: QuantPortfolioOwner): string {
  return `?${owner.filter}=${encodeURIComponent(owner.clientId)}`;
}
